<div class="zint-base-card d-flex justify-content-between w-100">
  <span class="text-grey-600">Use superuser token for read requests:</span>
  @if (crmService.wizardLoading().isLoadingWizardStepAction) {
    <zint-loader size="xSmall"></zint-loader>
  }
  <mat-slide-toggle [color]="'primary'" [(ngModel)]="useSuperuserToken" (ngModelChange)="updateChoiceAndGetStatus()">
  </mat-slide-toggle>
</div>
